import React from 'react';
import { Skeleton } from '../../components/ui/skeleton';

export const KanbanBoardSkeleton: React.FC = () => (
    <div className="p-8">
        <div className="mb-8 flex items-center justify-between">
            <div className="flex items-center gap-4">
                <Skeleton className="h-10 w-10 rounded-lg" />
                <Skeleton className="h-8 w-48" />
            </div>
            <div className="flex gap-3">
                <Skeleton className="h-10 w-32" />
                <Skeleton className="h-10 w-32" />
            </div>
        </div>

        <div className="flex gap-6 overflow-x-auto pb-4">
            {[1, 2, 3, 4].map((col) => (
                <div key={col} className="flex-shrink-0 w-80">
                    <div className="mb-4 p-4 rounded-xl bg-gray-50">
                        <div className="flex items-center justify-between mb-2">
                            <Skeleton className="h-6 w-32" />
                            <Skeleton className="h-6 w-8 rounded-full" />
                        </div>
                    </div>

                    <div className="space-y-3">
                        {[1, 2, 3].map((card) => (
                            <div key={card} className="p-4 rounded-xl bg-white border-2 border-gray-100 shadow-sm">
                                <div className="flex items-start justify-between mb-3">
                                    <div className="flex items-center gap-3 flex-1">
                                        <Skeleton className="h-10 w-10 rounded-full" />
                                        <div className="flex-1">
                                            <Skeleton className="h-5 w-32 mb-2" />
                                            <Skeleton className="h-4 w-24" />
                                        </div>
                                    </div>
                                    <Skeleton className="h-8 w-8 rounded-lg" />
                                </div>
                                <div className="flex items-center gap-2 mb-3">
                                    <Skeleton className="h-6 w-16 rounded-full" />
                                    <Skeleton className="h-6 w-20 rounded-full" />
                                </div>
                                <div className="flex items-center justify-between">
                                    <Skeleton className="h-4 w-28" />
                                    <div className="flex gap-2">
                                        <Skeleton className="h-8 w-8 rounded-lg" />
                                        <Skeleton className="h-8 w-8 rounded-lg" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default KanbanBoardSkeleton;
